import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';

// Import components
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutKhosikhadi from './components/AboutKhosikhadi';
import AboutBotswalle from './components/AboutBotswalle';
import Services from './components/Services';
import GetInvolved from './components/GetInvolved';
import Healing from './components/Healing';
import Art from './components/Art';
import Gallery from './components/Gallery';
import Connect from './components/Connect';

// Import styles
import './styles/custom.css';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll)
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });

    // Initialize AOS script from CDN
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js';
    script.onload = () => {
      if (window.AOS) {
        window.AOS.init({
          duration: 1000,
          once: true,
          offset: 100
        });
      }
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="App">
      <Helmet>
        <title>Botswalle Foundation - Khosikhadi Mmatlala wa Mudau | The Sisterhood Youth Foundation</title>
        <meta 
          name="description" 
          content="Botswalle - The Sisterhood Youth Foundation founded by Khosikhadi Mmatlala wa Mudau. Supporting young girls aged 15-21 through healing, mental health therapy, and community development in South Africa." 
        />
        <meta 
          name="keywords" 
          content="Botswalle, Botswalle Foundation, Khosikhadi Mmatlala, Khosikhadi Mmatlala wa Mudau, The Sisterhood, Youth Foundation, NGO South Africa, mental health therapy, healing, traditional healer, storyteller, poet, model, Ubuntu, Botho, Kliptown, Limpopo, Modjadji" 
        />
        <link rel="canonical" href="https://botswallethesisterhood.co.za/" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Botswalle Foundation - Khosikhadi Mmatlala wa Mudau | The Sisterhood Youth Foundation" />
        <meta property="og:description" content="Botswalle - The Sisterhood Youth Foundation founded by Khosikhadi Mmatlala wa Mudau. Supporting young girls aged 15-21 through healing, mental health therapy, and community development in South Africa." />
        <meta property="og:image" content="/images/image00007.jpeg" />
        <meta property="og:url" content="https://botswallethesisterhood.co.za/" />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Botswalle Foundation - Khosikhadi Mmatlala wa Mudau | The Sisterhood Youth Foundation" />
        <meta name="twitter:description" content="Botswalle - The Sisterhood Youth Foundation founded by Khosikhadi Mmatlala wa Mudau. Supporting young girls aged 15-21 through healing, mental health therapy, and community development in South Africa." />
        <meta name="twitter:image" content="/images/image00007.jpeg" />
      </Helmet>

      <Navigation />
      <HeroSection />
      <AboutKhosikhadi />
      <AboutBotswalle />
      <Services />
      <GetInvolved />
      <Healing />
      <Art />
      <Gallery />
      <Connect />
    </div>
  );
}

export default App;